export interface FundWithdrawalDetails {
  quoted_asset?: string;
  withdrawal_request_amount?: string | number;
  external_account_id?: string;
}

export interface JWTPayload {
  auth_embedded?: boolean;
  reference_id?: string;
  payload?: {
    use_new_sdk?: boolean;
    withdrawal_details?: FundWithdrawalDetails;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export function decodeJWT(token: string): JWTPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('[zh-web-sdk] Invalid JWT format');
      return null;
    }

    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch (error) {
    console.error('[zh-web-sdk] Error decoding JWT:', error);
    return null;
  }
}

// Issuers we accept for Connect Auth mode. Exact hostname match — no substring
// matching, to prevent attacker-controlled issuers like
// "https://attacker.com/connect" or "https://malicious-disconnect.io" from
// flipping the SDK into Auth mode. Add new tenants here explicitly.
export const ALLOWED_CONNECT_ISSUER_HOSTNAMES: readonly string[] = [
  'connect-xyz.us.auth0.com',
  'connect-xyz-dev.us.auth0.com',
];

export function isConnectIssuer(iss: unknown): boolean {
  if (typeof iss !== 'string') return false;
  try {
    const { hostname } = new URL(iss);
    return ALLOWED_CONNECT_ISSUER_HOSTNAMES.includes(hostname);
  } catch {
    return false;
  }
}

